import React from 'react'

const SlideComponent = ({ slideData, content }) => {
    return (
        slideData.isMainTitle ? 
            <div className="title-slide">
                <div className="title-slide-header"></div>
                <div className="title-slide-content">
                <h1 className="title-main">{slideData.title}</h1>
                <div className="title-subtitle">{content}</div>
                </div>
                <div className="title-slide-footer">
                    <span></span>
                    <span>Insight Note</span>
                </div>
            </div>
        :
            <div className="slide-content">
                <h2 className="slide-title">{slideData.title}</h2>
                <div className="slide-contents">{content}</div>
            </div>
        );
}

export default SlideComponent